var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsxs as _jsxs, jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { Grid, Link, Typography, styled } from '@mui/material';
import { useContext } from 'react';
import { useTerminologyTranslation } from '../../app/terminology';
import { Autocomplete, getUnassignedLOB, renderGroupedOptions } from '../../common';
import { WizardContext } from '../context';
import { useQueuesCopyFrom } from '../queue/selectors';
import { QueueStatusType } from '../queue/types';
import { useClearVolumeAPI, useCopyVolumeAPI } from '../workVolume/selectors';
var StyledContainer = styled(Grid)(function (_a) {
    var theme = _a.theme;
    return ({
        marginLeft: 'auto',
        flexShrink: 0,
        width: 'auto',
        maxWidth: theme.typography.pxToRem(600),
    });
});
export var CopyDataFrom = function (props) {
    var _a;
    var t = useTerminologyTranslation('wizard', { keyPrefix: 'copyData' }).t;
    var queues = useQueuesCopyFrom(props.statusType, props.getOptions);
    var _b = useClearVolumeAPI(props.statusType), fetchClearData = _b[1];
    var _c = useCopyVolumeAPI(props.statusType), copyVolume = _c[1];
    var _d = useContext(WizardContext), handleSave = _d.handleSave, handleSaveWithoutValidation = _d.handleSaveWithoutValidation, isDirty = _d.methods.formState.isDirty;
    var unassignedLOB = getUnassignedLOB();
    var saveBeforeAction = function (callback) {
        if ([
            QueueStatusType.Rate,
            QueueStatusType.HandleTime,
            QueueStatusType.LearnCurve,
            QueueStatusType.Attrition,
            QueueStatusType.WorkingDays,
            QueueStatusType.FTEDay,
        ].includes(props.statusType)) {
            return handleSaveWithoutValidation('submit', callback);
        }
        return handleSave('submit', callback)();
    };
    var handleCopy = function (source) {
        if (isDirty && props.needSaveBeforeCopy) {
            return saveBeforeAction(function () {
                if (props.onCopy) {
                    return props.onCopy(source);
                }
                return copyVolume(source);
            });
        }
        if (props.onCopy) {
            return props.onCopy(source);
        }
        return copyVolume(source);
    };
    var handleClear = function () {
        if (isDirty && props.needSaveBeforeCopy) {
            return saveBeforeAction(function () {
                if (props.onClear) {
                    return props.onClear();
                }
                return fetchClearData();
            });
        }
        if (props.onClear) {
            return props.onClear();
        }
        return fetchClearData();
    };
    return (_jsxs(StyledContainer, __assign({ container: true, wrap: "nowrap", justifyContent: "flex-end", alignItems: "center", columnSpacing: 2, mb: (_a = props === null || props === void 0 ? void 0 : props.mb) !== null && _a !== void 0 ? _a : undefined }, { children: [!props.disableCopy && (_jsxs(_Fragment, { children: [_jsx(Grid, __assign({ item: true, textAlign: "right", sx: { flexShrink: 0 } }, { children: _jsxs(Typography, { children: [" ", t('label')] }) })), _jsx(Grid, __assign({ item: true, sx: { minWidth: '16rem' } }, { children: _jsx(Autocomplete, { disabled: props.disabled, blurOnSelect: true, options: queues, placeholder: t('placeholder'), groupBy: function (option) { var _a; return (_a = option.lobName) !== null && _a !== void 0 ? _a : unassignedLOB; }, renderGroup: renderGroupedOptions, onChange: handleCopy, "data-testid": "copyDataSelect" }) }))] })), !props.disableClear && (_jsx(Grid, __assign({ item: true, textAlign: "right" }, { children: _jsx(Link, __assign({ component: "button", type: "button", onClick: handleClear, disabled: props.disabled, sx: {
                        display: 'inline-block',
                        whiteSpace: 'nowrap',
                        textAlign: 'right',
                    } }, { children: t('clearData') })) })))] })));
};
